export default {
  name: 'baseDialog',
  template: `
<el-dialog
  id="purchase-dialog"
  :key="dialogKey"
  :visible.sync="dialogVisible"
  :width="dialogWidth"
  >
  <div slot="title">
    <div v-if="step!=0">Покупка КриптоПро CSP для физических лиц, резидентов России</div>
  </div>
  <section v-if="step==0">
    <div class="h3 text-center mb-0">Выбор типа плательщика</div>
    <div class="text-center">Для продолжения покупки, пожалуйста, выберите подходящую вам категорию</div>
    <el-row :gutter="30" type="flex" style="margin: 30px 0 30px;">
  <el-col :span="12">
    <el-card shadow="hover" class="clickable-card" :body-style="{ height:'100%' }" @click.native="goToPersonal">
      <div class="card-content">
        <div class="icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#0055a2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-user"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path></svg>
        </div>
        <div class="card-info">
          <div class="card-title">
            <span class="font-osc">Физическое лицо</span>
            <div class="fw-normal" style="font-size:12px; line-height:16px;">резидент Российской Федерации</div>
          </div>
          <ul class="card-features">
            <li>Оплата онлайн</li>
            <li>Отправка лицензии онлайн</li>
            <li>Можно приобрести для нужд юридических лиц или ИП</li>
          </ul>
          <div class="card-bottom">
            Письмо со ссылкой на онлайн-загрузку будет отправлено на указанную при оформлении электронную почту не позднее рабочего дня, следующего за успешной оплатой.
          </div>
        </div>
      </div>
    </el-card>
  </el-col>
  <el-col :span="12">
    <el-card shadow="hover" class="clickable-card" :body-style="{ height:'100%' }" @click.native="goToBusiness">
      <div class="card-content">
        <div class="icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#0055a2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-buildings"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M4 21v-15c0 -1 1 -2 2 -2h5c1 0 2 1 2 2v15"></path><path d="M16 8h2c1 0 2 1 2 2v11"></path><path d="M3 21h18"></path><path d="M10 12v0"></path><path d="M10 16v0"></path><path d="M10 8v0"></path><path d="M7 12v0"></path><path d="M7 16v0"></path><path d="M7 8v0"></path><path d="M17 12v0"></path><path d="M17 16v0"></path></svg>
        </div>
        <div class="card-info">
          <div class="card-title">
            <div class="font-osc">ЮЛ, ИП, самозанятые,</div>
            <div class="fw-normal" style="font-size:12px; line-height:16px;">нотариусы, адвокаты, оценщики, управляющие, нерезиденты Российской Федерации</div>
          </div>
          <ul class="card-features">
            <li>Оплата по счёту</li>
            <li>Отправка лицензии в электронном виде</li>
            <li>Получение закрывающих документов через ЭДО или на бумажном носителе</li>
          </ul>
          <div class="card-bottom">
            В случае необходимости получить закрывающие документы в бумажном виде, доставка возможна курьерской службой в пределах МКАД или Почтой России.
          </div>
        </div>
      </div>
    </el-card>
  </el-col>
  </el-row>
    <div class="text-center"><el-link size="small" href="https://cryptopro.ru/buy">Подробнее об условиях и вариантах оплаты <i class="el-icon-document"></i> </el-link></div>
  </section>
  <el-card v-if="step != 0" shadow="never">
    <table-form v-show="step === 1" :isMobile="isMobile" @dialog="dialogVisible = $event" @cartData="stepCustomer($event)" @trigger-isReady="getProductsList" ref="tableForm"></table-form>
<!--    <el-link v-if="step === 2" class="fs-14" @click="step=1"><i class="el-icon-back"></i> Назад</el-link>-->
    <customer-form v-show="step === 2" :isMobile="isMobile" @dialog="dialogVisible = $event" @customerData="stepPurchase($event)" @stepDown="step--"></customer-form>
    <template v-if="step === 3">
        <section class="text-break">
            <section v-if="!isWaitResponse">
                <h3 class="my-0">Данные по заказу</h3>
                <div class="lead text-secondary">Пожалуйста, проверьте введённые данные перед оплатой</div>
                <div class="fs-9 font-osc fw-bold mt-4">Данные покупателя</div>
                <div><i class="el-icon-minus pe-2"></i>{{fullName}}</div>
                <div>
                  <i class="el-icon-minus pe-2"></i><strong>{{customerData.email}}</strong> <el-tooltip class="item" effect="dark" content="Это важно! На указанную почту будет отправлена дальнейшая информация о покупке."><i class="text-primary el-icon-warning"></i></el-tooltip>
                  <span> ← на указанную почту будет отправлено письмо.</span>
                </div>
                <div v-if="licenseOwner"><i class="el-icon-minus pe-2"></i>В лицензии будет указан конечный пользователь: <strong>{{licenseOwner}}</strong></div>
                <div class="fs-9 font-osc fw-bold mt-4">К оплате</div>
                <ol>
                  <li v-for="cart in cartData.cart" class="mb-1">
                    <span>{{cartData.details[cart.productId].fullName}} – <strong>{{cart.quantity}} шт.</strong></span>
                  </li>
                </ol>
                <div class="fs-9 font-osc fw-bold my-4">
                  <div><span class="fs-10 text-primary">ИТОГО К ОПЛАТЕ</span></div>
                  <div><span class="text-nowrap text-dark">{{$formatNumber(cartData.priceTotal)}} ₽</span></div>
                </div>
                <el-form :model="licenseForm" ref="licenseForm">
                  <el-form-item
                    prop="licenseAccepted"
                    :rules="[
                      {
                        validator: (rule, value, callback) => {
                          if (value === false) {
                            callback(new Error('Согласие обязательно'));
                          } else {
                            callback();
                          }
                        },
                        trigger: 'change'
                      }
                    ]"
                  >
                    <el-checkbox v-model="licenseForm.licenseAccepted">
                      <span>Ознакомлен и принимаю условия лицензионного соглашения</span>
                      <el-popover
                        placement="top-start"
                        width="274"
                        popper-class=""
                        visible-arrow="false"
                        trigger="hover">
                        <div class="p-2 text-start text-wrap text-break">Я подтверждаю своё согласие с <a href="/license" target="_blank">условиями лицензионного соглашения</a> ООО «КРИПТО-ПРО»</div>
                        <span slot="reference"> <i class="el-icon-info text-primary"></i></span>
                      </el-popover>
                    </el-checkbox>
                  </el-form-item>
                </el-form>
                <el-row>
                <el-button icon="el-icon-back" @click="step--">Назад</el-button>
                <el-button icon="el-icon-close" @click="dialogVisible = false">Отмена</el-button>
                <el-button type="primary" icon="el-icon-bank-card" @click="readySend" :loading="isWaitResponse">Перейти к оплате</el-button>
                </el-row>
            </section>
            <section v-else>
                <el-result title="Регистрируем ваш заказ." subTitle="Скоро вы будете перенаправлены на страницу оплаты.">
                    <template slot="icon">
                        <div v-loading="true">
                            <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" class="icon-success"><path d="M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M34.5548098,16.4485711 C33.9612228,15.8504763 32.9988282,15.8504763 32.4052412,16.4485711 L32.4052412,16.4485711 L21.413757,27.5805811 L21.413757,27.5805811 L21.4034642,27.590855 C21.0097542,27.9781674 20.3766105,27.9729811 19.9892981,27.5792711 L19.9892981,27.5792711 L15.5947588,23.1121428 C15.0011718,22.514048 14.0387772,22.514048 13.4451902,23.1121428 C12.8516033,23.7102376 12.8516033,24.6799409 13.4451902,25.2780357 L13.4451902,25.2780357 L19.6260786,31.5514289 C20.2196656,32.1495237 21.1820602,32.1495237 21.7756472,31.5514289 L21.7756472,31.5514289 L34.5548098,18.614464 C35.1483967,18.0163692 35.1483967,17.0466659 34.5548098,16.4485711 Z"></path></svg>
                        </div>
                        <!--<i class="el-icon-loading" style="font-size: 40px"></i>-->
                    </template>
                </el-result>
            </section>
        </section>
    </template>
  </el-card>
</el-dialog>
`,
  data: {
    step: 0, // 1 - Выбор позиций, 2 - Заполнение ФИО, 3 - Контрольный показ данных
    dialogKey: 0,
    dialogVisible: true,
    cartData: {},
    customerData: {},
    licenseOwner: null,
    releaseData: {
      cart: null,
      customer: null
    },
    commonErrorMessage: 'Платёжный шлюз временно недоступен. Повторите попытку через некоторое время.',
    isWaitResponse: false,
    licenseForm: {
      licenseAccepted: false
    }
  },
  computed: {
    isMobile: function () { return window.innerWidth < 820 },
    dialogWidth: function () {
      return this.isMobile ? '820px' : '820px'
    },
    fullName: function () {
      const patronymic = this.customerData.patronymic ? ' ' + this.customerData.patronymic : ''
      return this.customerData.surname + ' ' + this.customerData.name + patronymic
    }
  },
  methods: {
    goToPersonal () {
      this.step = 1
      // this.$router.push('/personal');
    },
    goToBusiness () {
      window.location.href = '/buy'
    },
    getProductsList: function () {
      // Загрузить данные
      try {
        const smartBuyExpiresAt = sessionStorage.getItem('smartBuyExpiresAt')
        if (smartBuyExpiresAt < Date.now()) {
          this.$refs.tableForm.requestData()
          return
        }
        const jsonData = sessionStorage.getItem('smartBuyOrder')
        const smartBuyOrder = JSON.parse(jsonData)
        if (!smartBuyOrder.crmObjectData) {
          this.$refs.tableForm.requestData()
        }
      } catch (e) {
        this.$refs.tableForm.requestData()
      }
    },
    stepCustomer (cartData) {
      this.cartData = JSON.parse(JSON.stringify(cartData))
      this.releaseData.cart = this.cartData.cart
      this.step = 2
    },
    stepPurchase (customerData) {
      this.customerData = JSON.parse(JSON.stringify(customerData))
      console.log('this.customerData', this.customerData)
      delete (this.customerData.policyAccepted)
      !this.customerData.isLicenseOwner ? this.licenseOwner = this.customerData.licenseOwner : this.licenseOwner = null
      delete (this.customerData.licenseOwner)
      delete (this.customerData.isLicenseOwner)
      delete (this.customerData.isRequiredPatronymic)
      this.customerData.email = this.customerData.email.toLowerCase()
      this.releaseData.customer = this.customerData
      this.releaseData.licenseOwner = this.licenseOwner
      this.releaseData.uuid = window.cpSite.plugin.createUUID()
      window.cpSite.module.smartcaptcha.activateAndSubscribeCallback(this.sendReleaseData, this.captchaError)
      this.step = 3
    },
    captchaError: function (e) {
      this.isWaitResponse = false
      this.$message({
        showClose: true,
        message: e.message,
        type: 'error',
        duration: 10000
      })
    },
    readySend () {
      this.$refs.licenseForm.validate((valid) => {
        if (valid) {
          this.sendReleaseData()
        }
      })
    },
    async sendReleaseData () {
      if (!window.smartCaptcha || !window.document.forms.captcha['smart-token']) {
        this.$message({
          showClose: true,
          message: 'У вас блокируется загрузка капчи. Попробуйте обновить страницу или сменить браузер.',
          type: 'error',
          duration: 10000
        })
        return
      }
      if (window.document.forms.captcha['smart-token'].value === '') {
        this.isWaitResponse = true
        window.smartCaptcha.execute()
        return
      }
      this.releaseData.token = window.document.forms.captcha['smart-token'].value
      try {
        const crm = await this.sendPostRequest(window.cpSite.module.purchaseForm.state.apiUrl, this.releaseData)
        this.$message({
          showClose: true,
          message: 'Данные приняты. Переход на страницу оплаты.',
          type: 'success',
          duration: 10000
        })
        window.location.href = crm.paymentLink
        // this.dialogVisible = false
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: 'error',
          duration: 10000
        })
        console.error(e)
        this.isWaitResponse = false
      }
      window.smartCaptcha.reset()
    },
    sendPostRequest: async function (url, data) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()

        xhr.open('POST', url, true)
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
              let response
              try {
                response = JSON.parse(xhr.responseText)
                /**
                 * Должны быть данные вида:
                 * {
                 *     "ok": true,
                 *     "crm": {
                 *         "createdOrderId": "123-123",
                 *         "paymentLink": "https://payecom.ru/pay_ru?orderId=123-123",
                 *         "hasError": false,
                 *         "message": null
                 *     }
                 * }
                 */

                /**
                 * ok:false в случае ошибки капчи или нарушения связи с CRM
                 * При этом сообщение сервера кладётся в error
                 */
                if (!response.ok) {
                  reject(new Error(response.error))
                }
                /**
                 * hasError:true в случае непринятия данных на CRM, тогда ожидаем сообщение самого CRM
                 */
                if (response.crm.hasError) {
                  reject(new Error(response.crm.message))
                  this.dialogVisible = false
                }
                /**
                 * Если в данных всё ещё null, то это неучтённая ошибка
                 */
                if (!response.crm.createdOrderId && !response.crm.paymentLink) {
                  reject(new Error(this.commonErrorMessage))
                }
              } catch (e) {
                /**
                 * Вернулись некорректные данные
                 */
                reject(new Error(this.commonErrorMessage))
              }
              resolve(response.crm)
            } else {
              /**
               * Вернулась непредвиденная ошибка
               */
              reject(new Error(this.commonErrorMessage))
            }
          }
        }

        xhr.onerror = () => {
          reject(new Error(this.commonErrorMessage))
        }

        try {
          xhr.send(JSON.stringify(data))
        } catch (e) {
          reject(new Error(this.commonErrorMessage))
        }
      })
    }
  },
  watch: {
    // Возвращения на шаг 1 после закрытия окна и повторного открытия
    dialogVisible (val) {
      if (val) {
        this.step = 0
        this.dialogKey++
        this.isWaitResponse = false

        // Добавление hash адрес
        if (window.location.hash !== '#smartbuy') {
          window.location.hash = '#smartbuy'
        }
      } else {
        // Удаление hash адреса и работа кнопки назад на форму
        if (window.location.hash === '#smartbuy') {
          window.history.pushState(null, '', window.location.pathname + window.location.search)
        }
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    // Очистка от устаревших сессий
    if (sessionStorage.getItem('smartBuyVersion') !== '64') {
      sessionStorage.clear()
      sessionStorage.setItem('smartBuyVersion', '64')
    }

    // Добавление hash адрес при первом запуске
    const hash = '#smartbuy'
    if (window.location.hash !== hash) {
      window.location.hash = hash
    }
    window.cpSite.module.purchaseForm.show = () => { this.dialogVisible = true }
    window.cpSite.module.purchaseForm.hide = () => { this.dialogVisible = false }

    const style = document.createElement('style')
    style.textContent = `
      #purchase-dialog .el-dialog__body {
        padding-top: 10px;
      }
      #purchase-dialog .el-dialog {
        background: #f8fafc;
      }
      .clickable-card {
        height: 100%;
        transition: all 0.3s;
        cursor: pointer;
      }
      .clickable-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
      .card-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 10px 0 10px;
        height: 100%;
      }
      .icon-container {
        margin-bottom: 15px;
      }
      .card-info {
        display: flex;
        flex-direction: column;
        word-break: normal;
        width: 100%;
        height: 100%;
      }
      .card-title {
        color: #0055a2;
        font-size: 24px;
        margin-bottom: 15px;
        font-weight: 700;
        border-bottom: 1px solid #f5f7fa;
        padding-bottom: 0.5rem;
        text-align: center;
      }
      .card-features {
        list-style-type: none;
        margin: 0 0 10px 0;
        text-align: left;
        list-style-image: url('data:image/svg+xml;utf8,<svg  xmlns="http://www.w3.org/2000/svg"  width="16"  height="16"  viewBox="0 0 24 24"  fill="none"  stroke="green"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 11l3 3l8 -8" /><path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg>');
      }
      .card-features li {
        padding-bottom: 7px;
        line-height: 1.2em;
      }
      .card-bottom {
        margin-top: auto;
        border-top: 1px solid #f5f7fa;
        padding-top: 0.5rem;
        font-size: 12px;
      }
    `
    document.head.appendChild(style)
  }
}
